<template>
  <div
    class="wc-dialog-overlay"
    v-if="props.modelValue"
    @click.self="handleClose"
    @touchmove.prevent
    @wheel.prevent
  >
    <div class="task-dialog" @touchmove.stop @wheel.stop>
      <div class="wc-dialog-header">
        <img :src="taskTitle" class="login-title" />
      </div>
      <div class="wc-dialog-body">
        <div class="task-list" v-if="sortedTaskList.length > 0">
          <div
            class="task-item"
            v-for="item in sortedTaskList"
            :key="item.taskType"
          >
            <div class="task-name">
              {{ $t(`wc2026.task.${item.taskType}`) }} 
              <template v-if="item.target">
                ({{ item.progress }}/{{ item.target }})

              </template>
            </div>
            <div class="task-award-info flex-center">
              <img
                src="~@/assets/imgs/act/wc2026/taskDialog/cheerIcon.png"
                class="task-reward-icon"
              />
              <div class="task-reward-count">+{{ item.CheerCount }}</div>
            </div>
            <div
              v-if="item.taskType === 'wc_weekly_share' && item.status === 0"
              class="task-btn flex-center todo"
              @click="handleViewTask(item)"
            >
              {{ $t("wc2026.share.text") }}
            </div>
            <div
              v-else
              class="task-btn flex-center "
              :class="getTaskBtnClass(item)"
              :disabled="item.status !== 1"
              @click="handleReceive(item)"
            >
              {{ getTaskBtnText(item) }}
            </div>
          </div>
        </div>
        <div class="empty-tip" v-else>
          {{ $t("wc2026.noData") }}
        </div>
      </div>
    </div>
  </div>
  <ShareDialog v-model="showShareDialog" @shareSuccess="onShareSuccess" />
</template>

<script setup>
/* eslint-disable */
import { computed, ref, defineProps, defineEmits,reactive, watch, onUnmounted } from "vue";
import { useI18n } from "vue-i18n";
import { toastService } from "@/utils/toastService";
import WcApi from "@/config/wcActApi";
import ShareDialog from "@/views/act/wc2026/components/ShareDialog/index.vue";
import { useLog } from "@/composables/useActLog";
import { useStore } from 'vuex'
const log = useLog();
const store = useStore()

// 禁止/恢复页面滚动
const lockScroll = () => {
  document.body.classList.add('no-scroll')
  document.documentElement.classList.add('no-scroll')
}

const unlockScroll = () => {
  document.body.classList.remove('no-scroll')
  document.documentElement.classList.remove('no-scroll')
}

import taskTitleVi from "@/assets/imgs/act/wc2026/taskDialog/titlevi.png";
import taskTitleTh from "@/assets/imgs/act/wc2026/taskDialog/titleth.png";
import taskTitleId from "@/assets/imgs/act/wc2026/taskDialog/titleid.png";
import taskTitleZh from "@/assets/imgs/act/wc2026/taskDialog/titlezh.png";
import taskTitleEn from "@/assets/imgs/act/wc2026/taskDialog/titleen.png";
const props = defineProps({
  modelValue: { type: Boolean, default: false },

});
const locale = useI18n().locale
const taskTitle = computed(() => {

  switch (locale.value) {
    case "vi":
      return taskTitleVi;
    case "th":
      return taskTitleTh;
    case "id":
      return taskTitleId;
    case "en":
      return taskTitleEn;
    case "tw":
      return taskTitleZh;
    case "hk":
      return taskTitleZh;
    default:
      return taskTitleEn;
  }
});
const emit = defineEmits(["update:modelValue", "received", "refreshActivity"]);
const { t } = useI18n();

const showShareDialog = ref(false);

const handleClose = () => {
  emit("update:modelValue", false);
};

const sortedTaskList = computed(() => {
  const order = { 1: 0, 0: 1, 2: 2 };
  return [...state.taskList].sort(
    (a, b) => (order[a.status] ?? 3) - (order[b.status] ?? 3),
  );
});

const getTaskBtnClass = (item) => {
  if (item.status === 1) return "can-receive";
  if (item.status === 2) return "received";
  return "not-done";
};

const getTaskBtnText = (item) => {
  if (item.status === 0) return t("wc2026.notReach");
  if (item.status === 1) return t("wc2026.canReceive");
  return t("wc2026.received");
};

const handleReceive = async (item) => {
  if (item.status !== 1) return;
  try {
    const res = await WcApi.receiveTaskReward({ taskType: item.taskType });
    log.track("act_worldcup_getcoin", {
      v1: item.taskType,
      v2: item.CheerCount,
    });
    item.status = 2;
    loadTaskList();
    store.dispatch("wcAct/fetchActivityInfo");
    toastService.show(t("mwr.mission.receiveRewardSuccess"));
  } catch (e) {
    console.error(e);
  }
};

const handleViewTask = (item) => {
  log.track("act_worldcup_gotask", {
    v1: item.taskType,
  });
  if (item.taskType === 'wc_weekly_share') {
    showShareDialog.value = true;
    handleClose()
    setTimeout(() => {
      WcApi.reportShare({
        shareType: 'wc_weekly_share',
      })
    
    }, 5000);
  }
};

const onShareSuccess = () => {
  emit("refreshActivity");
  emit("received", { taskType: 'wc_weekly_share' });
};

const state = reactive({
  taskList: [],
})

const loadTaskList = async () => {

  try {
    const res = await WcApi.getTaskList({})
    state.taskList = res.taskList || []
  } catch (e) {
    console.error(e)
  }
}

watch(() => props.modelValue, (val) => {
  if (val) {
    lockScroll()
    loadTaskList()
  } else {
    unlockScroll()
  }
}, { immediate: true })

onUnmounted(() => {
  unlockScroll()
})
</script>

<style lang="less" scoped>
@import "../shared.less";

.task-dialog {
  width: 673px;
  height: 439px;
  background-image: url("~@/assets/imgs/act/wc2026/dialog/bg.png");

  .wc-dialog-body {
    overflow-y: auto;
    overflow-x: hidden;
    flex: 1;
  }
}
.login-title {
  height: 41px;
  width: auto;
  display: block;
  margin: auto;
  margin-top: 20px;
  margin-bottom: 20px;
}
.task-list {
  overflow-x: hidden;
  width: 600px;
  margin: auto;
  height: 340px;
  overflow-y: auto;
}

.task-item {
  display: flex;
  width: 600px;
  height: 100px;
  align-items: center;
  margin-bottom: 10px;
  background-image: url("~@/assets/imgs/act/wc2026/taskDialog/task-item-bg.png");

  padding-left: 34px;
  padding-right: 42px;
  gap: 10px;
  &:last-child {
    margin-bottom: 0;
  }

  .task-name {
    flex: 1;
    font-weight: bold;
    font-size: 17px;
    color: #1B0926;
  }

  .task-award-info {
    .task-reward-icon {
      width: 37px;
      height: 35px;
    }
    .task-reward-count {
      color: #ff0000;
      font-size: 17px;
      font-weight: bold;
    }
  }


  .task-btn {
    flex-shrink: 0;
    &.can-receive , &.todo{
      font-size: 17px;
      color: #000;
      font-weight: bold;
      background-image: url("~@/assets/imgs/act/wc2026/taskDialog/can-revice-btn.png");
      width: 119px;
      height: 42px;
      cursor: pointer;
      &:hover {
        opacity: 0.8;
      }
    }

    &.not-done, &.received {
      width: 120px;
      height: 44px;
      background-image: url("~@/assets/imgs/act/wc2026/taskDialog/btn-gray.png");
      color: #fff;
      font-weight: bold;
      font-size: 17px;
      cursor: not-allowed;
    }


  }
}

.empty-tip {
  text-align: center;
  color: rgba(255, 255, 255, 0.3);
  padding: 40px 0;
  font-size: 24px;
}
</style>
